import { axios } from '@Root/API'

export const create = (id, payload) => {
	return axios.post(`student-registration/${id}/qualification-award`, payload)
}
